// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Main_mainWrapper__EewMC","fullMap":"Main_fullMap__1mOE7"};